<template>
  <div class="flex h-full">
    <div class="flex-1 h-full overflow-x-auto">
      <Attribution_Page
        :entity-ids="entityIds"
      />
    </div>
  </div>
</template>

<script>
import AttributionPage from "@/components/Attribution/Attribution_Page.vue";

export default {
  components: { Attribution_Page: AttributionPage },
  props: {
    entityIds: {
      type: Array,
      required: false,
      default: () => []
    },
    performanceDomainId: {
      type: Number,
      required: false,
    },
  },
}
</script>
